
<app-customgrid [gridOptions]="gridOptions" (checkboxSelections)="checkboxSelections($event)" (radioSelections)="radioSelections($event)" (hrefLink)="linkActivated($event);" ></app-customgrid>
